<template>
  <div class="bg-white sm:h-full">
    <header class="py-10">
      <div class="md:flex md:items-center md:justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate text-center">
            Start a Student Dataload
          </h2>
        </div>
      </div>
    </header>

    <main class="">
      <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">

        <div class="px-5 py-6 sm:px-6 border border-cool-gray-200 shadow rounded-lg">

          <div class="prose prose-md mx-auto">
            <p>
              To load student data into Cardstock, let's start by uploading a spreadsheet of student names and phone numbers.
            </p>
            <FilePicker
              class="mt-12 mx-auto"
              id="student-dataload-new"
              :allowMultiple="false"
              v-on:vfp-file-added="didAddFile"
            >
              <template v-slot:file-restriction>
                XLSX, CSV, or XLS up to 10MB
              </template>
            </FilePicker>
            <Toggle v-slot="{ toggle, didToggle }">
              <section>
                <h4 class="cursor-pointer select-none" @click="didToggle">
                  <svg
                    :class="{'transform rotate-90': toggle}"
                    class="mr-1 h-4 w-4 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150 inline-block rotate-90" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/solid.svg#caret-right"></use>
                  </svg>
                  How should my spreadsheet be formatted?
                </h4>
                <p v-show="toggle">
                  <span class="text-green-600 font-bold">GOOD</span>: Data with one-student-per-row and up to three phone numbers per student:
                </p>
                <p v-show="toggle">
                  <img src="/images/student-dataload-one-row.png" alt="" class="mx-auto shadow-xl">
                </p>
                <p v-show="toggle">
                <p v-show="toggle">
                  <span class="text-green-600 font-bold">ALSO GOOD</span>: Multiple rows per student with a new phone number in each row:
                </p>
                <p v-show="toggle">
                  <img src="/images/student-dataload-multi-row.png" alt="" class="mx-auto shadow-xl">
                </p>
              </section>
            </Toggle>
            <Toggle v-slot="{ toggle, didToggle }">
              <section>
                <h4 class="cursor-pointer select-none" @click="didToggle">
                  <svg
                    :class="{'transform rotate-90': toggle}"
                    class="mr-1 h-4 w-4 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150 inline-block rotate-90" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/solid.svg#caret-right"></use>
                  </svg>
                  What about the names of parents?
                </h4>
                <p v-show="toggle">
                  Cardstock allows you to provide a "label" for each phone number you assign to a student, which is a good place to store either the family member's name or their relationship to the student.
                </p>
                <p v-show="toggle">
                  <span class="text-green-600 font-bold">GOOD</span>: Providing family member names / relationships in a single column:
                </p>
                <p v-show="toggle">
                  <img src="/images/home-number-label-good.png" alt="" class="mx-auto shadow-xl">
                </p>
                <p v-show="toggle">
                  <span class="text-green-600 font-bold">ALSO GOOD</span>: Providing family member names / relationships in a single column for each of multiple phone numbers:
                </p>
                <p v-show="toggle">
                  <img src="/images/home-number-label-good-multi.png" alt="" class="mx-auto shadow-xl">
                </p>
                <p v-show="toggle">
                  <span class="text-red-600 font-bold">BAD</span>: Storing names across multiple columns:
                </p>
                <p v-show="toggle">
                  <img src="/images/home-number-label-bad.png" alt="" class="mx-auto shadow-xl">
                </p>
              </section>
            </Toggle>
            <Toggle v-slot="{ toggle, didToggle }">
              <section>
                <h4 class="cursor-pointer select-none" @click="didToggle">
                  <svg
                    :class="{'transform rotate-90': toggle}"
                    class="mr-1 h-4 w-4 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150 inline-block rotate-90" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                    <use href="/images/solid.svg#caret-right"></use>
                  </svg>
                  What filetypes do you accept?
                </h4>
                <p v-show="toggle">
                  We accept files ending in .xlsx, .csv., and .xls. If you need a starter template to work from, <a class="underline text-blue-600" href="https://cardstock.nyc3.digitaloceanspaces.com/Cardstock%20Student%20Upload%20Template.xlsx">you can download one by clicking here</a>.
                </p>
              </section>
            </Toggle>

          </div>

        </div>

      </div>
    </main>

  </div>
</template>

<script>
import axios from 'axios'
import FilePicker         from '@/components/FilePicker.vue'
import Toggle from '@/components/Toggle'

export default {
  components: {
    FilePicker,
    Toggle
  },
  props: {
    teamId: {
      required: true
    },
    currentUser: {
      required: true
    }
  },
  methods: {
    didAddFile(fileList) {
      var data = new FormData()
      data.append('file', fileList.item(0))
      data.append('teamId', this.teamId)

      axios.post('/student_dataload', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'auth': localStorage.getItem('cardstock_auth_token')
        }
      })
      .then(({data}) => {
        Bus.$emit('flash-message', {text: 'Spreadsheet uploaded successfully', type: 'success'})
        this.$router.push({name: 'studentDataloadProcess', params: {id: data.dataload.id}})
      })
      .catch((error) => {
        console.error("Cardstock: StudentDataloadNew file upload unhandleable error")
        Bus.$emit('flash-message', {text: error, type: 'error'})
      })
    }
  }
}
</script>
